var map = {
	"./google.png": "9ce7",
	"./hubspot-mini.png": "e1b1",
	"./hubspot.png": "c1be",
	"./integrations/zapier.png": "47aa",
	"./key.png": "a593",
	"./mailing-mini.png": "1584",
	"./mailing.png": "32af",
	"./microsoft.png": "d3f2",
	"./no-integration-to-add.png": "e740",
	"./oauth.png": "42af",
	"./salesforce-mini.png": "d06f",
	"./salesforce.png": "cf5d",
	"./whatsapp.png": "1545",
	"./zapier-mini.png": "820b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61b0";